import { render, staticRenderFns } from "./VisitStatus.vue?vue&type=template&id=639d98e3"
import script from "./VisitStatus.vue?vue&type=script&lang=ts"
export * from "./VisitStatus.vue?vue&type=script&lang=ts"
import style0 from "./VisitStatus.vue?vue&type=style&index=0&id=639d98e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports